"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "@/helpers/clsx";
import { useIsServer } from "@/helpers/useIsServer";
import { animate, frame, motion, useMotionTemplate, useMotionValue } from "framer-motion";
import React, { MouseEvent, useEffect, useRef } from "react";
export const useSpotlight = t0 => {
  const $ = _c(36);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    size: t2,
    initialY: t3,
    resetOnExit: t4,
    hideWhenInactive: t5,
    key
  } = t1;
  const size = t2 === undefined ? 0 : t2;
  const initialY = t3 === undefined ? 0 : t3;
  const resetOnExit = t4 === undefined ? true : t4;
  const hideWhenInactive = t5 === undefined ? false : t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const animations = useRef(t6);
  const containerRef = useRef(null);
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = getWindowWidth();
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const [width, setWidth] = React.useState(t7);
  const [isVisible, setIsVisible] = React.useState(!hideWhenInactive);
  let t8;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setWidth(containerRef.current?.clientWidth ?? getWindowWidth());
    };
    t9 = [];
    $[4] = t8;
    $[5] = t9;
  } else {
    t8 = $[4];
    t9 = $[5];
  }
  React.useEffect(t8, t9);
  const mouseX = useMotionValue(width / 2);
  const mouseY = useMotionValue(initialY);
  let t10;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      animations.current.forEach(_temp);
      animations.current = [];
    };
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  const resetAnimations = t10;
  let t11;
  if ($[7] !== isVisible || $[8] !== mouseX || $[9] !== mouseY) {
    t11 = function handleMouseMove(t12) {
      const {
        currentTarget,
        clientX,
        clientY
      } = t12;
      if (!isVisible) {
        setIsVisible(true);
      }
      let left;
      let top;
      frame.read(() => {
        resetAnimations();
        const bbox = currentTarget.getBoundingClientRect();
        left = bbox.left;
        top = bbox.top;
      });
      frame.render(() => {
        const newX = clientX - left;
        const newY = clientY - top;
        mouseX.set(newX);
        mouseY.set(newY);
      });
    };
    $[7] = isVisible;
    $[8] = mouseX;
    $[9] = mouseY;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  const handleMouseMove = t11;
  let t12;
  if ($[11] !== initialY || $[12] !== mouseX || $[13] !== mouseY) {
    t12 = t13 => {
      const withAnimation = t13 === undefined ? true : t13;
      const width_0 = containerRef.current?.clientWidth ?? 0;
      if (withAnimation) {
        frame.render(() => {
          animations.current.push(animate(mouseX, width_0 / 2, {
            duration: 0.5
          }));
          animations.current.push(animate(mouseY, initialY, {
            duration: 0.5
          }));
        });
      } else {
        mouseX.set(width_0 / 2);
        mouseY.set(initialY);
      }
    };
    $[11] = initialY;
    $[12] = mouseX;
    $[13] = mouseY;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const reset = t12;
  let t13;
  if ($[15] !== hideWhenInactive || $[16] !== reset) {
    t13 = () => {
      if (hideWhenInactive) {
        setIsVisible(false);
      }
      reset(false);
    };
    $[15] = hideWhenInactive;
    $[16] = reset;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== key) {
    t14 = [key];
    $[18] = key;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  useEffect(t13, t14);
  let t15;
  if ($[20] !== handleMouseMove) {
    t15 = e => handleMouseMove(e);
    $[20] = handleMouseMove;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== hideWhenInactive || $[23] !== reset || $[24] !== resetOnExit) {
    t16 = () => {
      if (hideWhenInactive) {
        setIsVisible(false);
      } else {
        if (resetOnExit) {
          reset();
        }
      }
    };
    $[22] = hideWhenInactive;
    $[23] = reset;
    $[24] = resetOnExit;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== handleMouseMove || $[27] !== t15 || $[28] !== t16) {
    t17 = {
      onMouseMove: handleMouseMove,
      onTouchMove: t15,
      onMouseLeave: t16,
      ref: containerRef
    };
    $[26] = handleMouseMove;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== isVisible || $[31] !== mouseX || $[32] !== mouseY || $[33] !== size || $[34] !== t17) {
    t18 = {
      containerProps: t17,
      mouseX,
      mouseY,
      size,
      isVisible
    };
    $[30] = isVisible;
    $[31] = mouseX;
    $[32] = mouseY;
    $[33] = size;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
};
export const Spotlight = ({
  mouseX,
  mouseY,
  size = 650,
  color = "rgba(16, 185, 129, 0.1)",
  className,
  isVisible
}: {
  mouseX: any;
  mouseY: any;
  size?: number;
  color?: string;
  className?: string;
  isVisible?: boolean;
}) => {
  const isServer = useIsServer();
  const scaledSize = getScaledSize(size);
  const background = useMotionTemplate`
    radial-gradient(
      ${scaledSize}px circle at ${mouseX}px ${mouseY}px,
      ${color},
      var(--transparent) 80%
    )
  `;
  if (isServer || !isVisible) return null;
  return <motion.div className={clsx("spotlight pointer-events-none absolute inset-0 z-10 rounded-[var(--radius)] opacity-100", isServer && "hidden", className)} style={{
    background
  }} />;
};
const getWindowWidth = () => {
  if (typeof window === "undefined") return 1216;
  return window.innerWidth;
};
const getScaledSize = (size: number) => {
  return Math.min(size, getWindowWidth() / 4);
};
function _temp(animation) {
  return animation.complete();
}